module.exports = __webpack_public_path__ + "static/img/rsna.77d8e16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rsna.svg
// module id = A8wZ
// module chunks = 1